import { archiverUrl, fetchWithAuthorization } from '../../helpers/utils';

const DeadlockApi = {
    fetch: (instanceType: string, timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/deadlock/${instanceType}?${timeRangeQS}&id=${instanceId}`),
};

export default DeadlockApi;
